import React, { useEffect, useState } from 'react';
import { Col, Row, Table, Alert, Button } from "react-bootstrap";
import { Dispatch, bindActionCreators, AnyAction } from 'redux';
import { connect } from 'react-redux';
import { historyActionCreators } from '../../store/HistoryStore';
import { AppState } from '../../store/configureStore';
import Skeleton from "react-loading-skeleton";
import { FileUpload } from "../FileUpload";
import { ConfirmModal } from "../ConfirmModal";
import { helperActionCreators } from '../../store/HelperStore';
import { Link } from 'react-router-dom';
import { Path } from '../../App';
import { detailsActionCreators } from '../../store/DetailsStore';
import { Permissions } from '../../store/HelperStore';
import { hasPermission } from '../../functions/hasPermission';
import RightMarginCMHistory from '../RightMarginCMHistory';

type TContributionHistroyProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;
const ContributionHistroy = (props: TContributionHistroyProps) => {
    const isLoading = (props.cmHistroy.isLoading && !props.cmHistroy.isLoaded);
    const isErr = props.cmHistroy.error;
    const isUploadVisible = (!isLoading && props.cmHistroy?.cmHistoryInfo?.cntb_history?.org_type?.toUpperCase() === "U");


    const [file, setFile] = useState<File | null>(null);
    const [showFileUploadPopup, setShowFileUploadPopup] = useState(false);
    const [uploadDate, setUploadDate] = useState("");

    const [selectedCCAID, setSelectedCCAID] = useState("");
    const [showCancelConfirmPopup, setShowCancelConfirmPopup] = useState(false);

    const allowCancel = (status: string) => {
        const orgType = props.cmHistroy.cmHistoryInfo.cntb_history.org_type.toUpperCase();
        const cancelUploadClaim = hasPermission(Permissions.ContributionHistory_CancelUpload, props.currentUserPermissions);
        const cancelEbillClaim = hasPermission(Permissions.ContributionHistory_CancelEbill, props.currentUserPermissions);

        if ((!cancelUploadClaim && orgType === 'U') || (!cancelEbillClaim && orgType !== 'U')) {
            return false;
        }

        if (status.toUpperCase() === "SCHEDULE PAYMENT" || status.toUpperCase() === "PENDING") {
            return true;
        }
    }

    function uploadWithFormData() {
        if (file) {
            props.uploadFile(file, uploadDate, props.dcr.selectedInstitution);
        }       
    }

    const cancelFileConfirmOkClick = () => {
        setShowCancelConfirmPopup(false);
        props.cancelFile(selectedCCAID, props.dcr.selectedInstitution);
    }

    const cancelFileConfirmReset = () => {
        setSelectedCCAID("");
        setShowCancelConfirmPopup(false);
    }

    const cancelLinkClick = (ccaid: string) => {
        setSelectedCCAID(ccaid);
        setShowCancelConfirmPopup(true);
    }

    const onFileUplaodCancelClick = (e: React.SetStateAction<boolean>) => {
        setFile(null);
        setUploadDate("");
        setShowFileUploadPopup(e);
        props.closeUploadPopup();
    }

    useEffect(() => {
        setShowFileUploadPopup(props.cmHistroy.isUploadFileError ?? false)
    }, [props.cmHistroy.isUploadFileError]
    );


    return (
        <>
            {isLoading && <LoadingSkeleton />}

            {props.cmHistroy.isLoaded &&
                <div style={{ paddingTop: "1rem" }}>
                    <div className="col-xl-9" style={{ float: "left" }}>
                        <Row className="tbl-info-wrap">
                            <Col className="float-xs-left col-12 col-sm-7 col-lg-8 col-xl-9">
                                <h4>Contribution History</h4>
                            </Col>
                            <Col className="my-2 my-sm-0 float-xs-right col-12 col-sm-5 col-lg-4 col-xl-3">
                                <form>
                                    {isUploadVisible &&
                                        <Button type="button"
                                            className="btn-block btn-primary mb-1"
                                            onClick={() => { setShowFileUploadPopup(true) }} >Upload Payroll File</Button>
                                    }
                                    <FileUpload
                                        isShowingModal={showFileUploadPopup}
                                        resetModalState={(e: React.SetStateAction<boolean>) => { onFileUplaodCancelClick(e) }}
                                        onFileChange={(e: { target: { files: React.SetStateAction<File | null>[]}}) => { setFile(e.target.files[0]) }}
                                        onOKClick={uploadWithFormData}
                                        onDateChange={(date: string) => setUploadDate(date)}
                                        isUploadError={props.cmHistroy.isUploadFileError ?? false}
                                        uploadErrorMessage={props.cmHistroy.errorMessage ?? ""}
                                        currentUser={props.currentUser}
                                        historyFiles={props.cmHistroy.cmHistoryInfo?.cntb_history?.files}
                                    />
                                </form>
                            </Col>
                        </Row>

                        <Row className="mb-2">
                            <Col>Select a payroll date below to view or edit the data in the file.</Col>
                        </Row>
                        {!isErr ?
                            <div className="widetable widetable-min-width widetable-overflow-ffx">
                                <Table className="table table-bordered table-striped table-fixed">
                                    <thead>
                                        <tr className="border-bottom pl-2 table-borderless" style={{ display: "table", width: "100%", tableLayout: "fixed", minWidth: "880px" }}>
                                            <th>
                                                Payroll Date
                                    </th>
                                            <th>
                                                Total
                                    </th>
                                            <th>
                                                Status
                                    </th>
                                            <th>
                                                Status Date
                                    </th>
                                            <th>
                                                &nbsp;
                                    </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {props.cmHistroy.cmHistoryInfo.cntb_history.files.map((item, i) =>
                                            <tr key={i} style={{ display: "table", width: "100%", tableLayout: "fixed", minWidth: "880px" }}>
                                                <td>
                                                    <Link to={Path.ContributionDetails}
                                                        onClick={() => {
                                                            props.setCmDetailsDefaults(props.cmHistroy.cmHistoryInfo.cntb_history.org_type, item.status, props.currentUser.userName, item.payroll_date, item.status_date, item.sched_date, props.cmHistroy.cmHistoryInfo.cntb_history.sched_type);
                                                            props.fetchCMDetails(item.cca_id, 1, 50, "y", true, true, true)
                                                        }}>
                                                        {item.payroll_date}
                                                    </Link>
                                                </td>
                                                <td className="pl-2">
                                                    {item.total}
                                                </td>
                                                <td
                                                    className="pl-2"
                                                    style={{
                                                        color: item.status?.toUpperCase() === "SCHEDULE PAYMENT" ? "red" : "black"
                                                    }}
                                                >
                                                    {item.status?.toUpperCase() === "SCHEDULE PAYMENT"
                                                        ? "Your Action Needed"
                                                        : item.status}
                                                </td>
                                                <td className="pl-2">
                                                    {item.status_date}
                                                </td>
                                                <td className="text-left">
                                                    {allowCancel(item.status) && <Button className="my-0 py-0"
                                                        onClick={() => cancelLinkClick(item.cca_id)} variant="link">Cancel File</Button>}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                            : <Alert className="mt-2" variant="danger">Unable to fetch Contribution History: {props.cmHistroy.errorMessage}</Alert>
                        }
                    </div>
                    <div className="col-xl-3 pnl-summry mb-4">
                        <RightMarginCMHistory />
                    </div>
                </div>
            }

            <ConfirmModal isShowingModal={showCancelConfirmPopup} okClick={() => cancelFileConfirmOkClick()}
                resetModalState={() => cancelFileConfirmReset()} okayBtnText="OK" modelTitle="Cancel File">
                <Row>
                    <Col>
                        Cancelling this file will delete all contribution information in this file. Do you want to continue?
                    </Col>
                </Row>
            </ConfirmModal>
        </>
    )
}

const LoadingSkeleton = () => (
    <div className="row container">
        <div className="col-12 pl-2">
            <div className="mt-2"><Skeleton width={'100%'} /></div>
            <div><Skeleton width={'95%'} /></div>
            <div className="mt-2"><Skeleton width={'100%'} /></div>
            <div><Skeleton width={'95%'} /></div>
            <div className="mt-2"><Skeleton width={'100%'} /></div>
            <div><Skeleton width={'95%'} /></div>
            <div className="mt-2"><Skeleton width={'100%'} /></div>
            <div><Skeleton width={'95%'} /></div>
            <div className="mt-2"><Skeleton width={'100%'} /></div>
            <div><Skeleton width={'95%'} /></div>
            <div className="mt-2"><Skeleton width={'100%'} /></div>
            <div><Skeleton width={'95%'} /></div>
            <div className="mt-2"><Skeleton width={'100%'} /></div>
            <div><Skeleton width={'95%'} /></div>
        </div>
    </div>
);

function mapStateToProps(state: AppState) {
    return {
        dcr: state.dcr,
        cmHistroy: state.cmHistory,
        currentUserPermissions: state.dcr.currentuserInfo?.user?.permissions,
        currentUser: state.dcr.currentuserInfo.user
    }
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators(
        {
            ...historyActionCreators,
            ...detailsActionCreators,
            ...helperActionCreators
        }, dispatch);
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ContributionHistroy);